import logo from '@assets/logo.png';
import { UI_SIZE } from '@constants/ui';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import { styled, type SxProps, type Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useAppSelector } from '@store/hooks';
import MenuContent from '../Menu/MenuContent';
import OptionsMenu from '../OptionsMenu';

const SideBar = () => {
  const user = useAppSelector((state) => state.auth.user);

  return (
    <Drawer variant='permanent' sx={permanentDrawerStyles}>
      <Box sx={logoBoxStyles}>
        <img src={logo} alt='SuPAR' width={150} />
        <Typography variant='caption' sx={productNameStyles}>Private License Server</Typography>
      </Box>
      <Divider style={{ marginBottom: '14px' }} />
      <Box sx={menuBoxStyles}>
        <MenuContent />
      </Box>
      <Stack direction='row' sx={userInfoStackStyles}>
        <Avatar sizes='small' alt={user?.name} sx={avatarStyles} />
        <Box sx={{ marginRight: 'auto' }}>
          <Typography variant='body2' sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {user?.name}
          </Typography>
          <Typography variant='caption' sx={{ color: 'text.secondary' }}>
            {user?.username}
          </Typography>
        </Box>
        <OptionsMenu />
      </Stack>
    </Drawer>
  );
};

const Drawer = styled(MuiDrawer)({
  width: UI_SIZE.DRAWER_WIDTH,
  flexShrink: 0,
  boxSizing: 'border-box',
  [`& .${drawerClasses.paper}`]: {
    width: UI_SIZE.DRAWER_WIDTH,
    boxSizing: 'border-box',
  },
});

const permanentDrawerStyles: SxProps<Theme> = {
  display: { xs: 'none', md: 'none', lg: 'block' },
  [`& .${drawerClasses.paper}`]: {
    backgroundColor: 'background.paper',
  },
};

const logoBoxStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '12px',
  marginTop: 'calc(var(--template-frame-height, 0px) + 4px)',
  padding: 1.5,
};

const productNameStyles: SxProps<Theme> = {
  color: 'text.secondary',
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  fontSize: '0.65rem',
  marginTop: '4px',
  marginLeft: '2px',
};

const menuBoxStyles: SxProps<Theme> = {
  overflow: 'auto',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '6px !important',
  paddingRight: '6px !important',
};

const userInfoStackStyles: SxProps<Theme> = {
  padding: 2,
  gap: 1,
  alignItems: 'center',
  borderTop: '1px solid',
  borderColor: 'divider',
};

const avatarStyles: SxProps<Theme> = {
  width: 36,
  height: 36,
  marginRight: '6px',
};

export default SideBar;
